import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WebCamContainer from "./CustomWebcam";

const App = () => {
  return (
    <BrowserRouter basename="/scanner">
      <div className="App">
        <Routes>
          <Route path="/:albumId" element={<WebCamContainer />} />
          <Route path="/" element={
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <h2>URL inválida</h2>
              <p>Accede con un álbum válido: /scanner/1</p>
            </div>
          } />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;